'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  height: 52px;\n'], ['\n  height: 52px;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Button = require('../Button');
var _Footer = require('../Common/Footer');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ConfirmationDialogFooter = (0, _styledComponents2['default'])(_Footer.Footer)(_templateObject);
var ConfirmationDialogBase = function (_React$Component) {
  _inherits(ConfirmationDialogBase, _React$Component);
  function ConfirmationDialogBase(props) {
    _classCallCheck(this, ConfirmationDialogBase);
    var _this = _possibleConstructorReturn(this, (ConfirmationDialogBase.__proto__ || Object.getPrototypeOf(ConfirmationDialogBase)).call(this, props));
    var showOverlay = false;
    if (_this.props.show === true) {
      showOverlay = true;
    }
    _this.state = {
      show: showOverlay
    };
    _this.renderBody = _this.renderBody.bind(_this);
    _this.cancelClickHandler = _this.cancelClickHandler.bind(_this);
    _this.rightPanePrimaryButtonClickHandler = _this.rightPanePrimaryButtonClickHandler.bind(_this);
    _this.rightPaneSecondaryButtonClickHandler = _this.rightPaneSecondaryButtonClickHandler.bind(_this);
    _this.leftPaneSecondaryButtonClickHandler = _this.leftPaneSecondaryButtonClickHandler.bind(_this);
    _this.leftPanePrimaryButtonClickHandler = _this.leftPanePrimaryButtonClickHandler.bind(_this);
    _this.renderFooter = _this.renderFooter.bind(_this);
    return _this;
  }
  _createClass(ConfirmationDialogBase, [{
    key: 'render',
    value: function () {
      function render() {
        var id = this.props.id || _lodash2['default'].uniqueId('confirmationDialog_');
        if (this.state.show === true) {
          return _react2['default'].createElement('div', {
            id: id,
            className: this.props.className,
            'data-test-id': 'confirmation-dialog-container'
          }, _react2['default'].createElement('div', {
            name: 'dialogBackdrop'
          }), _react2['default'].createElement('div', {
            name: 'modal'
          }, this.props.labels.headerText ? _react2['default'].createElement('div', {
            name: 'header'
          }, _react2['default'].createElement('div', {
            name: 'headerTitle'
          }, this.props.labels.headerText)) : null, this.renderBody(), this.props.type && this.renderFooter()));
        } else {
          return null;
        }
      }
      return render;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        if (typeof newProps.show === 'boolean') {
          this.setState({
            show: newProps.show
          });
        }
      }
      return componentWillReceiveProps;
    }()
  }, {
    key: 'renderFooter',
    value: function () {
      function renderFooter() {
        var rightPanePrimaryButtonText = this.props.labels.rightPanePrimaryButtonText || '[Ok]';
        var rightPaneSecondaryButtonText = this.props.labels.rightPaneSecondaryButtonText || '[SaveAndClose]';
        var leftPaneSecondaryButtonText = this.props.labels.leftPaneSecondaryButtonText || '[Back]';
        var leftPanePrimaryButtonText = this.props.labels.leftPanePrimaryButtonText || '[Discard]';
        var cancelButtonText = this.props.labels.cancelButtonText || '[Cancel]';
        var primaryRightPaneButtonId = this.props.primaryRightPaneButtonId || _lodash2['default'].uniqueId('confirmationDialogRightPanePrimaryButton_');
        var secondaryRightPaneButtonId = this.props.secondaryRightPaneButtonId || _lodash2['default'].uniqueId('confirmationDialogRightPaneSecondaryButton_');
        var secondaryLeftPaneButtonId = this.props.secondaryLeftPaneButtonId || _lodash2['default'].uniqueId('confirmationDialogLeftPaneSecondaryButton_');
        var primaryLeftPaneButtonId = this.props.primaryLeftPaneButtonId || _lodash2['default'].uniqueId('confirmationDialogLeftPanePrimaryButton_');
        var cancelButtonId = this.props.cancelButtonId || _lodash2['default'].uniqueId('confirmationDialogCancelButton_');

        /*
          Adding this in because we are passing all props through
          to the buttons and the type prop is incorrect and should
          not be passed through.
        */
        var buttonProps = _extends({}, this.props, {
          type: 'button'
        });
        var footer = _react2['default'].createElement(ConfirmationDialogFooter, null, _react2['default'].createElement(_Footer.RightPane, null, _react2['default'].createElement(_Button.PrimaryButton, _extends({
          id: primaryRightPaneButtonId,
          inline: true,
          text: rightPanePrimaryButtonText,
          clickHandler: this.rightPanePrimaryButtonClickHandler
        }, buttonProps))));
        switch (this.props.type) {
          case 'delete':
            break;
          case 'discard':
            footer = _react2['default'].createElement(ConfirmationDialogFooter, null, _react2['default'].createElement(_Footer.LeftPane, null, _react2['default'].createElement(_Button.PrimaryButton, _extends({
              'data-test-id': 'left-primary-button',
              id: primaryLeftPaneButtonId,
              inline: true,
              text: leftPanePrimaryButtonText,
              clickHandler: this.leftPanePrimaryButtonClickHandler
            }, buttonProps))), _react2['default'].createElement(_Footer.RightPane, null, _react2['default'].createElement(_Button.SecondaryButton, {
              'data-test-id': 'right-secondary-button',
              id: cancelButtonId,
              text: cancelButtonText,
              clickHandler: this.cancelClickHandler
            }), _react2['default'].createElement(_Button.PrimaryButton, _extends({
              'data-test-id': 'right-primary-button',
              id: primaryRightPaneButtonId,
              inline: true,
              text: rightPanePrimaryButtonText,
              clickHandler: this.rightPanePrimaryButtonClickHandler
            }, buttonProps))));
            break;
          case 'info':
            footer = _react2['default'].createElement(ConfirmationDialogFooter, null, _react2['default'].createElement(_Footer.RightPane, null, _react2['default'].createElement(_Button.PrimaryButton, {
              'data-test-id': 'right-primary-button',
              id: primaryRightPaneButtonId,
              inline: true,
              text: rightPanePrimaryButtonText,
              clickHandler: this.rightPanePrimaryButtonClickHandler
            })));
            break;
          case 'save':
            footer = _react2['default'].createElement(ConfirmationDialogFooter, null, _react2['default'].createElement(_Footer.RightPane, null, _react2['default'].createElement(_Button.SecondaryButton, {
              'data-test-id': 'right-secondary-button',
              id: cancelButtonId,
              text: cancelButtonText,
              clickHandler: this.cancelClickHandler
            }), _react2['default'].createElement(_Button.PrimaryButton, _extends({
              'data-test-id': 'right-primary-button',
              id: primaryRightPaneButtonId,
              inline: true,
              text: rightPanePrimaryButtonText,
              clickHandler: this.rightPanePrimaryButtonClickHandler
            }, buttonProps))));
            break;
          case 'savewithsecondary':
            footer = _react2['default'].createElement(ConfirmationDialogFooter, null, _react2['default'].createElement(_Footer.LeftPane, null, _react2['default'].createElement(_Button.SecondaryButton, {
              'data-test-id': 'left-secondary-button',
              id: secondaryLeftPaneButtonId,
              text: leftPaneSecondaryButtonText,
              clickHandler: this.leftPaneSecondaryButtonClickHandler
            })), _react2['default'].createElement(_Footer.RightPane, null, _react2['default'].createElement(_Button.SecondaryButton, {
              'data-test-id': 'right-secondary-button',
              id: cancelButtonId,
              text: cancelButtonText,
              clickHandler: this.cancelClickHandler
            }), _react2['default'].createElement(_Button.PrimaryButton, _extends({
              'data-test-id': 'right-primary-button',
              id: primaryRightPaneButtonId,
              inline: true,
              text: rightPanePrimaryButtonText,
              clickHandler: this.rightPanePrimaryButtonClickHandler
            }, buttonProps))));
            break;
          case 'saveandclose':
            footer = _react2['default'].createElement(ConfirmationDialogFooter, null, _react2['default'].createElement(_Footer.LeftPane, null, _react2['default'].createElement(_Button.SecondaryButton, {
              'data-test-id': 'left-secondary-button',
              id: secondaryLeftPaneButtonId,
              text: leftPaneSecondaryButtonText,
              clickHandler: this.leftPaneSecondaryButtonClickHandler
            })), _react2['default'].createElement(_Footer.RightPane, null, _react2['default'].createElement(_Button.SecondaryButton, {
              'data-test-id': 'right-secondary-button',
              id: cancelButtonId,
              text: cancelButtonText,
              clickHandler: this.cancelClickHandler
            }), _react2['default'].createElement(_Button.SecondaryButton, _extends({
              'data-test-id': 'right-secondary-button',
              id: secondaryRightPaneButtonId,
              text: rightPaneSecondaryButtonText,
              clickHandler: this.rightPaneSecondaryButtonClickHandler
            }, buttonProps)), _react2['default'].createElement(_Button.PrimaryButton, _extends({
              'data-test-id': 'right-primary-button',
              id: primaryRightPaneButtonId,
              inline: true,
              text: rightPanePrimaryButtonText,
              clickHandler: this.rightPanePrimaryButtonClickHandler
            }, buttonProps))));
            break;
        }
        return footer;
      }
      return renderFooter;
    }()
    /**
     * Function to render the body of the dialog. We are going to overload this dialog to either
     * display a confirmation message or display the children of the dialog - which can be a form like behavior.
     */
  }, {
    key: 'renderBody',
    value: function () {
      function renderBody() {
        if (this.props.message && this.props.message.length > 0) {
          return _react2['default'].createElement('div', {
            name: 'bodyContainer',
            'data-test-id': 'confirmation-dialog-body'
          }, this.props.message);
        } else {
          return _react2['default'].createElement('div', {
            name: 'bodyContainer',
            'data-test-id': 'confirmation-dialog-body'
          }, this.props.children);
        }
      }
      return renderBody;
    }()
  }, {
    key: 'cancelClickHandler',
    value: function () {
      function cancelClickHandler(evt) {
        var _this2 = this;
        this.setState({
          show: false
        }, function () {
          if (typeof _this2.props.cancelClickHandler === 'function') {
            _this2.props.cancelClickHandler();
          }
        });
        evt.stopPropagation();
      }
      return cancelClickHandler;
    }()
  }, {
    key: 'rightPanePrimaryButtonClickHandler',
    value: function () {
      function rightPanePrimaryButtonClickHandler(evt) {
        if (typeof this.props.rightPanePrimaryButtonClickHandler === 'function') {
          this.props.rightPanePrimaryButtonClickHandler();
        }
        evt.stopPropagation();
      }
      return rightPanePrimaryButtonClickHandler;
    }()
  }, {
    key: 'rightPaneSecondaryButtonClickHandler',
    value: function () {
      function rightPaneSecondaryButtonClickHandler(evt) {
        if (typeof this.props.rightPaneSecondaryButtonClickHandler === 'function') {
          this.props.rightPaneSecondaryButtonClickHandler();
        }
        evt.stopPropagation();
      }
      return rightPaneSecondaryButtonClickHandler;
    }()
  }, {
    key: 'leftPaneSecondaryButtonClickHandler',
    value: function () {
      function leftPaneSecondaryButtonClickHandler(evt) {
        if (typeof this.props.leftPaneSecondaryButtonClickHandler === 'function') {
          this.props.leftPaneSecondaryButtonClickHandler();
        }
        evt.stopPropagation();
      }
      return leftPaneSecondaryButtonClickHandler;
    }()
  }, {
    key: 'leftPanePrimaryButtonClickHandler',
    value: function () {
      function leftPanePrimaryButtonClickHandler(evt) {
        if (typeof this.props.leftPanePrimaryButtonClickHandler === 'function') {
          this.props.leftPanePrimaryButtonClickHandler();
        }
        evt.stopPropagation();
      }
      return leftPanePrimaryButtonClickHandler;
    }()
  }]);
  return ConfirmationDialogBase;
}(_react2['default'].Component);
ConfirmationDialogBase.defaultProps = {
  type: undefined,
  labels: {}
};
ConfirmationDialogBase.propTypes = {
  /**
   * The id of the cancel button on the confirmation dialog. If not provided a unique id will be used.
   */
  cancelButtonId: _propTypes2['default'].string,
  /**
   * Handler called when the cancel button is clicked.
   */
  cancelClickHandler: _propTypes2['default'].func,
  /**
   * Array of name value pairs with localized labels.
   */
  labels: _propTypes2['default'].shape({
    /**
     * Title of the Overlay.
     */
    headerText: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    /**
     * The text for the Primary button.
     */
    rightPanePrimaryButtonText: _propTypes2['default'].string,
    /**
     * The text for the right Secondary button.
     */
    rightPaneSecondaryButtonText: _propTypes2['default'].string,
    /**
     * The text for the left Primary button.
     */
    leftPanePrimaryButtonText: _propTypes2['default'].string,
    /**
     * The text for the left Secondary button.
     */
    leftPaneSecondaryButtonText: _propTypes2['default'].string,
    /**
     * The text for the cancel button.
     */
    cancelButtonText: _propTypes2['default'].string
  }),
  /**
   * Handler to be passed into the component. It is called when the primary button in the left pane is clicked.
   */
  leftPanePrimaryButtonClickHandler: _propTypes2['default'].func,
  /**
   * Handler to be passed into the component. It is called when the secondary button in the left pane is clicked.
   */
  leftPaneSecondaryButtonClickHandler: _propTypes2['default'].func,
  /**
   * The message in the overlay.
   */
  message: _propTypes2['default'].string,
  /**
   * This allows content to overflow the modal body on the y axis for the modal. An example of a necessary usage for this would be a dropdown that needs to extend past the modal.
   */
  overflowY: _propTypes2['default'].bool,
  /**
   * The id of the left button on the confirmation dialog. If not provided a unique id will be used.
   */
  primaryLeftPaneButtonId: _propTypes2['default'].string,
  /**
   * The id of the primary button on the confirmation dialog. If not provided a unique id will be used.
   */
  primaryRightPaneButtonId: _propTypes2['default'].string,
  /**
   * Handler to be passed into the component. It is called when the primary button in the right pane is clicked.
   */
  rightPanePrimaryButtonClickHandler: _propTypes2['default'].func,
  /**
   * Handler to be passed into the component. It is called when the secondary button in the right pane is clicked.
   */
  rightPaneSecondaryButtonClickHandler: _propTypes2['default'].func,
  /**
   * The id of the second secondary button on the right of confirmation dialog. If not provided a unique id will be used.
   */
  secondaryRightPaneButtonId: _propTypes2['default'].string,
  /**
   * The id of the first secondary button on the left of confirmation dialog. If not provided a unique id will be used.
   */
  secondaryLeftPaneButtonId: _propTypes2['default'].string,
  /**
   * Toggle to show or hide the overlay. False by default.
   */
  show: _propTypes2['default'].bool,
  /**
   * Theme for the confirmation dialog.
   */
  theme: _propTypes2['default'].object,
  /**
     * The type of overlay to show. Behavior of type 'discard, info and save' is currently implemented. When type is set to info the secondary button - cancel is hidden.
      * For all other types both the primary and secondary button are shown.
      * discard: Shows a button on the left side of the footer - used for Discard functionality and a primary (Save) and secondary (Cancel) button on the right side of the footer.
      * save: The save type shows a primary and secondary (cancel) buttons in the right side of the footer. THis type can also be used for confirmation scenarios.
      * savewithsecondary: This type shows a primary and one secondary (cancel) buttons in the right side of the footer and a secondary button on the left side.
      * saveandclose: The save type shows two primary and one secondary (cancel) buttons in the right side of the footer. This type can also be used for running multiple events.
      * info: Shows a message to the user. THe user can dismiss the dialog using the primary 'Ok' button.
      * delete: The behavior for delete is not implemented yet.
     */
  type: _propTypes2['default'].oneOf(['delete', 'discard', 'info', 'save', 'saveandclose', 'savewithsecondary'])
};
ConfirmationDialogBase.displayName = 'ConfirmationDialog';
exports['default'] = ConfirmationDialogBase;